
import React from 'react';
import Image from 'next/image';

import IGenericOption from '../../interfaces/IGenericOption';

import tickIcon from '../../public/assets/icons/tick.svg';
import styles from './styles.module.scss';
import { useIsBoiWebsite } from "../Context/WebsiteType";

interface IRadioButtonComponent {
  isChecked: boolean;
  radioButton: IGenericOption;
  setSelected(selected: IGenericOption): void; 
}

const RadioButton = ({ isChecked = false, radioButton, setSelected }: IRadioButtonComponent) => {

  const isBoiWebsite = useIsBoiWebsite();

  return (
    <div className={`${isBoiWebsite ? styles.radioButtonHolderBoi : styles.radioButtonHolder}`} 
      onClick={() => {
        if (setSelected) setSelected(radioButton)}
      }
    >
      
      <div className={`${isBoiWebsite ? styles.radioButtonBoi : styles.radioButton} ${isChecked ? isBoiWebsite ? styles.checkedBoi : styles.checked : ""}`}>
        {
          isChecked 
          ? <Image src={ tickIcon } alt="" />
          : <>&nbsp;</>
        }
      </div>
      
      <p className={`${isBoiWebsite ? styles.radioTextBoi : styles.radioText}`}>{ radioButton.label }</p>

    </div>
  );
};

export default RadioButton;